module.exports = __webpack_public_path__ + "static/img/1-2.cfb6c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/1-2.png
// module id = 945
// module chunks = 30